import { useDispatch, useSelector } from "react-redux";
import { setIsExpandSelectedZone, setIsExpandUnselectedZone } from "../../store/cleaning/cleaningSlice";

export const useExpandSelectedZone = () => {
  const dispatch = useDispatch();
  // const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const isExpanded = useSelector(
    (state: any) => state.cleaning.isExpandSelectedZone
  );
  const setIsExpanded = (value: boolean) => {
    dispatch(setIsExpandSelectedZone({ value }));
  };

  return {
    isExpanded,
    setIsExpanded,
  };
};

export const useExpandUnselectedZone = () => {
  const dispatch = useDispatch();
  // const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const isExpanded = useSelector(
    (state: any) => state.cleaning.isExpandUnselectedZone
  );
  const setIsExpanded = (value: boolean) => {
    dispatch(setIsExpandUnselectedZone({ value }));
  };

  return {
    isExpandedUnselected: isExpanded,
    setIsExpandedUnselected: setIsExpanded,
  };
};
